<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-4/12"
      appearance="outline"
    >
      <mat-label>Mensagem do Lembrete</mat-label>
      <mat-select formControlName="messages">
        @for (message of messagesList; track message){
        <mat-option [value]="message.id">{{message.texto}}</mat-option>
        }
      </mat-select>
    </mat-form-field>


    <mat-form-field class="input-tg mt-message-input w-4/12" appearance="outline">
      <mat-label>Dias da Semana</mat-label>
      <mat-select multiple formControlName="weekDays">
        <mat-option *ngFor="let type of diasSemanaList" [value]="type.id">
          {{ type.descricao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-4/12"
      appearance="outline"
    >
      <mat-label>Horário do Lembrete</mat-label>
      <mat-select multiple formControlName="time">
        @for (message of timeList; track message){
          <mat-option [value]="message.id">{{message.hora}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancelar
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
